import React from 'react'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { Text } from 'app/common/typography'
import { Close } from 'app/assets/icons'
import { media } from 'app/assets/styles'

const { error } = colors

type Props = {
    text: string,
    description?: string | null,
    backgroundColor?: string,
    onClose?: () => any,
    sticky?: boolean,
    isCart?: boolean
}

const ErrorBanner = (props: Props) => {
    const {
        backgroundColor = error,
        description,
        isCart,
        onClose,
        text,
        sticky
    } = props
    return (
        <Container sticky={sticky} isCart={isCart} style={{ backgroundColor }}>
            <TextContainer>
                <Text color="white">{text + '\n'}</Text>
                {!!description && (
                    <Text color="white" style={{ marginTop: 15 }}>
                        - {description}
                    </Text>
                )}
            </TextContainer>
            <CloseContainer onClick={onClose}>
                <Close color="white" size={24} />
            </CloseContainer>
        </Container>
    )
}

const Container = styled.div`
    padding: 10px 44px 10px 10px;
    position: relative;
    z-index: 1;
    top: ${props => (props.isCart ? 100 : 60)}px;
    ${media.medium`
         top: ${props => (props.isCart ? 124 : 90)}px;
    `}
    ${props =>
        props.sticky &&
        `
        position: fixed;
        width: 100%;
        z-index: 200;
    `};
`

const TextContainer = styled.div`
    white-space: pre-line;
`

const CloseContainer = styled.div`
    position: absolute;
    right: 15px;
    ${media.medium`
         right: 200px;
    `}
    top: 10px;
    z-index: 300;
    cursor: pointer;
`

export { ErrorBanner }
